import { AxiosError as AxiosErrorType } from 'axios';

class AxiosError extends Error {
  request: string;
  date: Date;
  details: { [key: string]: any };
  message: string;
  constructor(request = 'Non défini', details, ...params) {
    super(...params);
    // Maintenir dans la pile une trace adéquate de l'endroit où l'erreur a été déclenchée (disponible seulement en V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AxiosError);
    }
    this.name = 'AxiosError';
    // Informations de déboguage personnalisées
    this.request = request;
    this.details = details;
    this.message =
      details?.message[0]?.messages[0]?.id ||
      details?.response?.data?.data[0]?.messages[0]?.message ||
      `Erreur serveur  ${request} ${details?.message}`;
    this.date = new Date();
  }
}

export default AxiosError;

type StrapiErrorData = { error: { message: string } };

export const getAxiosMessageError = (
  error: AxiosErrorType<StrapiErrorData>
): string => {
  return error.isAxiosError
    ? error.response?.data?.error?.message
    : 'Erreur inatendue';
};
